var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUploadImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 39,
    viewBox: "0 0 39 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.5 5.5H5.5C4.43913 5.5 3.42172 5.92143 2.67157 6.67157C1.92143 7.42172 1.5 8.43913 1.5 9.5V29.5M1.5 29.5V33.5C1.5 34.5609 1.92143 35.5783 2.67157 36.3284C3.42172 37.0786 4.43913 37.5 5.5 37.5H29.5C30.5609 37.5 31.5783 37.0786 32.3284 36.3284C33.0786 35.5783 33.5 34.5609 33.5 33.5V25.5M1.5 29.5L10.672 20.328C11.4221 19.5781 12.4393 19.1569 13.5 19.1569C14.5607 19.1569 15.5779 19.5781 16.328 20.328L21.5 25.5M33.5 17.5V25.5M33.5 25.5L30.328 22.328C29.5779 21.5781 28.5607 21.1569 27.5 21.1569C26.4393 21.1569 25.4221 21.5781 24.672 22.328L21.5 25.5M21.5 25.5L25.5 29.5M29.5 5.5H37.5M33.5 1.5V9.5M21.5 13.5H21.52",
    stroke: "#A6A6A6",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadImage);
export default __webpack_public_path__ + "static/media/uploadImage.66ea0ecb671bba99f8bdf27ccf19362a.svg";
export { ForwardRef as ReactComponent };